/** moderator/ontology — API (match-scoped observational decision record). */
import { http } from '../../_shared/http';
import type { OntologyDecisionPacket, OntologyDecisionRecord, OntologyEvaluation, OntologySessionAuditStatus } from './types';

const seg = encodeURIComponent;

/** Correlation window used when pulling the discussion around an action. */
const DISCUSSION_WINDOW_SECONDS = 300;

export const ontologyApi = {
  status: (matchId: string) =>
    http.get<OntologySessionAuditStatus>(`/ontology/sessions/${seg(matchId)}/status`),
  decisions: (matchId: string, cohortId: string) =>
    http.get<OntologyDecisionRecord[]>(`/ontology/sessions/${seg(matchId)}/decisions?cohortId=${seg(cohortId)}`),
  evaluations: (matchId: string, cohortId: string) =>
    http.get<OntologyEvaluation[]>(`/ontology/sessions/${seg(matchId)}/evaluations?cohortId=${seg(cohortId)}`),
  action: (matchId: string, actionId: string) =>
    http.get<OntologyDecisionPacket>(
      `/ontology/sessions/${seg(matchId)}/actions/${seg(actionId)}?discussionWindowSeconds=${DISCUSSION_WINDOW_SECONDS}`,
    ),
  /** Revise a draft's prose. Evidence references are not editable by design. */
  updateEvaluation: (
    matchId: string,
    evaluationId: string,
    changes: {
      processAssessment?: string;
      outcomeAssessment?: string;
      narrative?: string;
    },
  ) =>
    http.patch<OntologyEvaluation>(
      `/evaluations/ontology/${seg(matchId)}/${seg(evaluationId)}`,
      changes,
    ),
  publishEvaluation: (matchId: string, evaluationId: string) =>
    http.post<OntologyEvaluation>(`/evaluations/ontology/${seg(matchId)}/${seg(evaluationId)}/publish`),
};
